import { createMuiTheme } from '@material-ui/core/styles';

export const zeus = {
  page: '#151718',
  surface: '#101010',
  raised: '#202020',
  border: '#303030',
  text: '#ECEDEE',
  muted: '#999999',
  accent: '#CF6679',
};

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: { main: '#ffffff' },
    secondary: { main: zeus.accent },
    background: { default: zeus.page, paper: zeus.surface },
    text: { primary: zeus.text, secondary: zeus.muted },
    divider: zeus.border,
  },
  overrides: {
    MuiAppBar: { colorPrimary: { backgroundColor: zeus.surface, color: '#fff', borderBottom: `1px solid ${zeus.border}` } },
    MuiDrawer: { paper: { backgroundColor: zeus.surface, borderRight: `1px solid ${zeus.border}` } },
    MuiPaper: { rounded: { borderRadius: 12 } },
    MuiLink: { root: { color: zeus.muted } },
  },
});

export default theme;
